import { FCWithChildren } from '@types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  GuestButtons,
  GuestDeviceConfirm,
  GuestIdentifiedPopup,
  Modal,
  ModalBody,
} from '@components';
import useLayoutContext from '@hooks/useLayoutContext';
import { getDeviceStatus } from 'sdk-apogee';
import { getSubdomain } from '@utils';
import usePageTitle from '@hooks/usePageTitle';
import { deviceProps } from '@components/GuestDeviceConfirm/GuestDeviceConfirm';

type DeviceConflictModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  isAutoDetect?: boolean;
  isAutoDetectSignedIn?: boolean;
};

const GuestProcessing: FCWithChildren<DeviceConflictModalProps> = () => {
  usePageTitle('Account Processing');
  const history = useHistory();
  const SUBDOMAIN = getSubdomain();
  const { startHereSsid = null, testCaptiveMac = null } = useLayoutContext();
  const [deviceStatus, setDeviceStatus] = useState<deviceProps>();

  useEffect(() => {
    if (testCaptiveMac) {
      getDeviceStatus({
        domain: SUBDOMAIN,
        macAddress: testCaptiveMac || '',
      }).then((res) => {
        setDeviceStatus(res);
      });
    }
  }, []);

  const closeModal = () => {
    return history.push('/');
  };

  const GuestBandWidthPopup = () => (
    <ModalBody>
      <div className="mb-2 text-center">
        <h2 style={{ fontSize: '125%' }} className="pb-5">
          Almost there - your account is being created!
        </h2>
      </div>
      <div className="mb-12 text-center">
        While we finish setting things up, click Continue to get immediate guest access to the
        internet. We’ll email you as soon as your account is ready with instructions to get started.
      </div>
      <GuestButtons />
    </ModalBody>
  );

  return (
    <Modal closeModal={closeModal} isOpen={true}>
      {!testCaptiveMac ? (
        <GuestIdentifiedPopup startHereSsid={startHereSsid} />
      ) : deviceStatus?.userType === 'guest' ? (
        <GuestDeviceConfirm deviceStatus={deviceStatus} />
      ) : (
        <GuestBandWidthPopup />
      )}
    </Modal>
  );
};

export default GuestProcessing;
